import { AccordionItemsCompletionHandler } from './accordion-items-completion-handler';
import { AdmonitionsCompletionHandler } from './admonitions-completion-handler';
import { ClickImageItemsCompletionHandler } from './click-image-items-completion-handler';
import { FlipcardItemsCompletionHandler } from './flipcard-items-completion-handler';
import { HotspotItemsCompletionHandler } from './hotspot-items-completion-handler';
import { QuestionsCompletionHandler } from './questions-completion-handler';
import { TabsCompletionHandler } from './tabs-completion-handler';
//import { QuizCompletionHandler } from './quiz-completion-handler';

export const handlers = [
  AccordionItemsCompletionHandler,
  AdmonitionsCompletionHandler,
  ClickImageItemsCompletionHandler,
  FlipcardItemsCompletionHandler,
  HotspotItemsCompletionHandler,
  QuestionsCompletionHandler,
  TabsCompletionHandler,
//  QuizCompletionHandler
];
